import { render } from "./MarcaNegocios.vue?vue&type=template&id=3eeab287&scoped=true"
import script from "./MarcaNegocios.vue?vue&type=script&lang=js"
export * from "./MarcaNegocios.vue?vue&type=script&lang=js"

import "./MarcaNegocios.vue?vue&type=style&index=0&id=3eeab287&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eeab287"]])

export default __exports__